<template>
  <div class="content bg8">
    <div class="middled">
            <div class="basehero" style="">
        <h1 style="text-align: center;">One Place to Align Your Team</h1>
        <p style="text-align: center;">Start FREE for 30 days</p>
        <div class="row">
          <div class="column">
            <div style="padding:0 10px;background:#f0f8ff;border:4px solid #ccc;flex:1;">
              <h3 style="text-align:center" title="Small Team">Small Team</h3>
              <ul class="pricing-list">
                <li>5 Program Boards</li>
                <li>3 Team Members</li>
                <li>Vision/Mission Workspace</li>
                <li>Strategy Frameworks</li>
                <li>Marketing Frameworks</li>
                <li>V2MOM Boards</li>
                <li>OKR Boards</li>
                <li>AI-enhanced Tasks</li>
                <li>Progress Tracking</li>
                <li>Visual Reporting</li>
              </ul>
              <p style="font-size:2rem;text-align:center">
                $75<br>
                <span style="font-size:.8rem;">per month</span>
              </p>
              <p style="text-align:center">
                <a href="https://buy.stripe.com/eVq3cubvm4YFaUe9cK14403" target="_blank" rel="nofollow">
                  <button style="padding:10px 20px;"> Free Trial </button>
                </a>
              </p>
            </div>
          </div>
          <div class="column">
            <div style="padding:0 10px;background:#f0f8ff;border:4px solid #BF00FF;flex:1;">
              <h3 style="text-align:center" title="Pro Team">Growing Team</h3>
              <ul class="pricing-list">
                <li>15 Program Boards</li>
                <li>10 Team Members</li>
                <li>Vision/Mission Workspace</li>
                <li>Strategy Frameworks</li>
                <li>Marketing Frameworks</li>
                <li>V2MOM Boards</li>
                <li>OKR Boards</li>
                <li>AI-enhanced Tasks</li>
                <li>Progress Tracking</li>
                <li>Visual Reporting</li>
              </ul>
              <p style="font-size:2rem;text-align:center">
                $149<br>
                <span style="font-size:.8rem;">per month</span>
              </p>
              <p style="text-align:center">
                <a href="https://buy.stripe.com/eVq28qari62J5zUdt014404" target="_blank" rel="nofollow">
                  <button style="padding:10px 20px;background: #BF00FF;"> Free Trial </button>
                </a>
              </p>
            </div>
          </div>
          <div class="column">
            <div style="padding:0 10px;background:#f0f8ff;border:4px solid #ccc;flex:1;">
              <h3 style="text-align:center" title="Full Team"> Full Team </h3>
              <ul class="pricing-list">
                <li>Unlimited Program Boards</li>
                <li>30 Team Members</li>
                <li>Vision/Mission Workspace</li>
                <li>Strategy Frameworks</li>
                <li>Marketing Frameworks</li>
                <li>V2MOM Boards</li>
                <li>OKR &amp; Custom Boards</li>
                <li>AI-enhanced Tasks</li>
                <li>Progress Tracking</li>
                <li>Visual Reporting</li>
              </ul>
              <p style="font-size:2rem;text-align:center">
                $349<br>
                <span style="font-size:.8rem;">per month</span>
              </p>
              <p style="text-align:center">
                <a href="https://buy.stripe.com/6oU00i6b29eV5zU0Ge14405" target="_blank" rel="nofollow">
                  <button style="padding:10px 20px;"> Free Trial </button>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="basehero" style="padding:0 40px;text-align: center;">
        <h2>Need Help Hiring a Team?</h2>
        <p>
          Check out our <a href="/who-we-serve" class="pink">Managed Internship Programs</a>.
        </p>
      </div>

    </div>
    
    <div class="middled">
      <div class="basehero" style="text-align: center;margin: 0 10%;">
        <h2>Flexible Pricing and Programs</h2>
        <p>
          Each client is unique, so we offer flexible pricing plans tailored to your specific needs. 
        </p>
        <p>
          Our <a href="/who-we-serve">managed internship programs</a> are designed to fit your budget and goals, 
          whether you're a startup or an established business.
          Contact us to discuss your needs and find the right plan for your business.
        </p>
        <p>
          <a href="https://calendly.com/foclarity/30min" target="_blank" rel="nofollow">
            <button style="padding:10px 20px;background:#fff;border:1px solid #BF00FF;color:#BF00FF;">Schedule a Call</button>
          </a>
        </p>
      </div>
    </div>
    
  </div>
</template>

<script>
import { isLoggedIn } from "../utils/auth";

export default {
  title: 'Pricing | Foclarity',
  name: "Pricing",
  mounted: function() {
    if (isLoggedIn()) {
      // this.$router.push("dashboards");
    }
  },
  methods: {
    isLoggedIn() {
      return isLoggedIn();
    },
    checkForMetaMask: function () {
      //Have to check the ethereum binding on the window object to see if it's installed
      const { ethereum } = window;
      var isinstalled = Boolean(ethereum && ethereum.isMetaMask);
      console.log("Metamask is connected: " + isinstalled)

      try {
        // Will open the MetaMask UI
        // You should disable this button while the request is pending!
        ethereum.request({ method: "eth_requestAccounts" });
      } catch (error) {
        console.error(error);
      }

    },
  },
  components: {},
  data () {
      return {
      }
  },
  created () {
    // this.checkForMetaMask() ;
  }
};
</script>

<style lang="scss" scoped>

.heroblue {
  background: linear-gradient(110deg, #00b2ee 60%, #007cee 60%);
  height: 320px;
  margin: -20px -20px 20px -20px;
  border-radius: 4px 4px 0 0;
  @media only screen and (max-width: 440px) {
    border-radius: 0px 0px 0 0;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  & h1 {
    text-align: center;
    color: #fff;
    font-size: 45px;
    max-width: 600px;
    @media (max-width: 415px) {
      font-size: 36px;
      padding: 20px;
    }
  }
  & a {
    text-decoration: none;
    color: #fff;
    & .signupbox {
      text-align: center;
      padding: 8px;
      font-size: 24px;
      font-weight: bold;
      background: #ff7f24;
      width: 300px;
      border-radius: 10px;
      border: 1px solid #fff;
      margin: auto;
    }
  }
}

.row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  padding: 10px;
  min-width: 200px;
  & .homecard {
    text-align: center;
    padding: 20px;
    border-radius: 4px;
    background: rgba(0, 178, 238, 0.1);
    height: 100%;
    & .cardicon {
      width: 100px;
      height: 100px;
      margin: auto;
      & img {
        width: 80px;
      }
    }
    & .h3 {
      font-size: 23px;
      line-height: 32px;
      color: #CC0099;
      text-align: left;
      @media (max-width: 400px) {
        font-size: 20px;
      }
    }
  }
}

.homequote {
  text-align: center;
  font-size: 24px;
  line-height: 32px;
  font-style: italic;
  color: #666;
  max-width: 600px;
  margin: 20px auto;
}
.pricing-list {
  list-style-type: none;
  padding: 0;
  & li {
    padding: 10px;
    border-bottom: 1px solid #ccc;
  }
}
</style>

